import { useCallback, useEffect, useState } from "react";
import ERC20 from "../assets/abis/ERC20.json";
import PairAbi from "../assets/abis/PairAbi.json";
import RouterAbi from "../assets/abis/RouterAbi.json";
import FactoryAbi from "../assets/abis/Factor.json";
import useRouter from "./useRouter";
import { useChainId, useConfig } from "wagmi";
import { getAddress, isAddress } from "viem";
import { readContracts } from '@wagmi/core'
import { useAccount } from "wagmi";
import { formatUnits, parseUnits } from "viem";
import { useClient, useWriteContract } from "wagmi";
import { ETHER, Token } from "../constants/types";
import { wrappedCurrency } from "../utils/trade"
import { estimateGas,waitForTransactionReceipt} from "viem/actions"
import {encodeFunctionData} from "viem"

function usePairInfo(tokenA, tokenB) {
  const account = useAccount();
  const chainId = useChainId()
  const config = useConfig()
  const router = useRouter();
  const { writeContractAsync } = useWriteContract();
  const client = useClient()
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [txhash, setTxHash] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  useEffect(() => {
    const fetch = async () => {
      try {
        if (!tokenA || !tokenB) return
        if (tokenA === ETHER) tokenA = wrappedCurrency(tokenA, chainId);
        if (tokenB === ETHER) tokenB = wrappedCurrency(tokenB, chainId);
        const FactoryAddress = await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              address: router,
              abi: RouterAbi,
              functionName: "factory"
            }
          ]
        })

        const pairAddress = await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              address: FactoryAddress[0],
              abi: FactoryAbi,
              functionName: "getPair",
              args: [tokenA.address, tokenB.address]
            }
          ]
        })
        console.log("pairAddress",pairAddress)
        if(pairAddress[0]==='0x0000000000000000000000000000000000000000') {
          setData({userBalance:0,tokenABalance:0,tokenBBalance:0,percent:0,decimals:18,isNewPair:true})
          return
        }
        const address = getAddress(pairAddress[0])
        const result = await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              address: address,
              abi: ERC20,
              functionName: 'balanceOf',
              args: [account.address]
            },
            {
              address: address,
              abi: ERC20,
              functionName: 'totalSupply'
            },
            {
              address: address,
              abi: PairAbi,
              functionName: 'getReserves'
            },
            {
              address: address,
              abi: ERC20,
              functionName: 'decimals'
            },
            {
              address: address,
              abi: PairAbi,
              functionName: 'token0'
            },
            {
              address: address,
              abi: PairAbi,
              functionName: 'token1'
            }
          ]
        })
        const token0 = result[4];
        const token1 = result[5];
        const reserves = result[2]; // [reserve0, reserve1]
        let reserveA, reserveB;

        if (tokenA && tokenA.address.toLowerCase() === token0.toLowerCase()) {
          reserveA = reserves[0];
          reserveB = reserves[1];
        } else if (tokenA && tokenA.address.toLowerCase() === token1.toLowerCase()) {
          reserveA = reserves[1];
          reserveB = reserves[0];
        } else {
          return
          throw new Error('tokenA not found in pair');
        }
        const userBalance = parseFloat(formatUnits(result[0], result[3])).toFixed(6)
        const percent = Number(result[0] * 100n) / Number(result[1])
        const tokenAAmountBigInt = (Number(reserveA) * percent * 10000) / 1000000;
        // tokenAAmountBigInt=BigInt(tokenAAmountBigInt);
        // console.log(tokenA)
        const tokenABalanceStr = tokenAAmountBigInt/10**tokenA.decimals;
        const tokenABalance = Number(Number(tokenABalanceStr).toFixed(6));
        const tokenBAmountBigInt = (Number(reserveB) * percent * 10000) / 1000000;
        const tokenBBalanceStr = tokenBAmountBigInt/10**tokenB.decimals;
        const tokenBBalance = Number(Number(tokenBBalanceStr).toFixed(6));
        setData({ userBalance, tokenABalance, tokenBBalance, percent, decimals: result[3] ,isNewPair:false,tokenA_reserve:reserveA,tokenB_reserve:reserveB,lp_total_supply:result[1]})
      } catch (e) {
        console.log(e)
      }
    }

    if (config) {
      fetch()
    } else {
      setData(null)
    }
  }, [fetch, config, chainId, refreshTime, account.address, tokenA, tokenB, router, RouterAbi])
  const onRemovePair = useCallback(async (percent) => {
    try {
      setLoading(true)
      try {
        // const randomAmount = generateRandomAmount();
        const parameters = {
            to: router,
            account: account.address,
          }

          parameters.data = encodeFunctionData({
              abi: RouterAbi,
              functionName: 'removeLiquidity',
              args: [tokenA.address, tokenB.address, parseUnits((data.userBalance * percent / 100).toString(), data.decimals), 0n, 0n, account.address, Date.now() + 200],
            })
            // parameters.value = amounts[0]
            const result = await estimateGas(client, parameters)
                  // gas提高8%
            const gasLimit=(result + result * 80n / 100n)
        const hash = await writeContractAsync({
          abi: RouterAbi,
          address: router,
          functionName: 'removeLiquidity',
          gasLimit,
          args: [tokenA.address, tokenB.address, parseUnits((data.userBalance * percent / 100).toString(), data.decimals), 0n, 0n, account.address, Date.now() + 200],
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
        setTxHash(hash)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client, writeContractAsync, tokenA, tokenB, data, account, router, RouterAbi]);
  const onAddPair = useCallback(async (amountA, amountB) => {
    try {
      setLoading(true)
      try {
        // const randomAmount = generateRandomAmount();
        console.log(tokenA, tokenB, amountA, amountB)
        let Call;
        if (tokenA === ETHER) {
          tokenA = wrappedCurrency(tokenA, chainId);
          Call = {
            functionName: "addLiquidityETH",
            args: [ tokenB.address, parseUnits(amountB, tokenB.decimals), 0n, 0n, account.address, Date.now() + 200],
            value: parseUnits(amountA, tokenA.decimals)
          }
        } else if (tokenB === ETHER) {
          tokenB = wrappedCurrency(tokenB, chainId);
          Call = {
            functionName: "addLiquidityETH",
            args: [tokenA.address, parseUnits(amountA, tokenA.decimals), 0n, 0n, account.address, Date.now() + 200],
            value: parseUnits(amountB, tokenB.decimals)
          }
        } else {
          Call = {
            functionName: 'addLiquidity',
            args: [tokenA.address, tokenB.address, parseUnits(amountA, tokenA.decimals), parseUnits(amountB, tokenB.decimals), 0n, 0n, account.address, Date.now() + 200]
          }
        }
        console.log("Call",Call)
        const parameters = {
            to: router,
            account: account.address,
          }
        parameters.data = encodeFunctionData({abi:RouterAbi,...Call})
        if(tokenA===ETHER) parameters.value = parseUnits(amountA, tokenA.decimals)
        if(tokenB===ETHER) parameters.value = parseUnits(amountB, tokenB.decimals) 
          console.log("parameters",parameters)
        const result = await estimateGas(client, parameters)
                  // gas提高8%
        const gasLimit=(result + result * 80n / 100n)
        console.log("gasLimit",gasLimit)
        const hash = await writeContractAsync({
          abi: RouterAbi,
          address: router,
          gasLimit,
          ...Call
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
        return hash
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client, writeContractAsync, waitForTransactionReceipt, tokenA, tokenB, data, account, router, RouterAbi]);
  return { data, onRemovePair, onAddPair, isLoading ,txhash}
}

export default usePairInfo